import { makeAutoObservable, runInAction } from 'mobx'
import agent from '../api/agent'
import { Arduino } from '../models/arduino'

export default class ArduinoStore {
  arduinoRegistry = new Map<string, Arduino>()
  selectedArduino: Arduino | undefined = undefined
  editMode = false
  loading = false
  updatedValue = false
  newValue = 0
  loadingInitial = true

  constructor () {
    makeAutoObservable(this)
  }

  get arduinos () {
    return Array.from(this.arduinoRegistry.values())
  }
  // get activitiesByDate() {
  //   return Array.from(this.arduinoRegistry.values()).sort(
  //     (a, b) => Date.parse(a.date) - Date.parse(b.date)
  //   );
  // }

  loadArduinos = async () => {
    this.loadingInitial = true
    try {
      const activities = await agent.Arduinos.list()
      activities.forEach((arduino) => {
        this.setArduino(arduino)
      })
      this.loadingInitial = false
    } catch (error) {
      console.log(error)
      this.setLoadingInitial(false)
    }
  }

  loadArduino = async (id: string) => {
    let arduino = this.getArduino(id)
    if (arduino) {
      this.selectedArduino = arduino
      return arduino
    } else {
      this.loadingInitial = true
      try {
        arduino = await agent.Arduinos.details(id)
        this.setArduino(arduino)
        runInAction(() => {
          this.selectedArduino = arduino
        })
        this.setLoadingInitial(false)
        return arduino
      } catch (error) {
        console.log(error)
        this.setLoadingInitial(false)
      }
    }
  }

  private setArduino = (arduino:Arduino) => {
    // arduino.date = arduino.date.split("T")[0];
    this.arduinoRegistry.set(arduino.id, arduino)
  }

  private getArduino = (id: string) => {
    return this.arduinoRegistry.get(id)!
  }

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state
  }

  createArduino = async (arduino: Arduino) => {
    this.loading = true
    try {
      await agent.Arduinos.create(arduino)
      runInAction(() => {
        this.arduinoRegistry.set(arduino.id, arduino)
        this.selectedArduino = arduino
        this.editMode = false
        this.loading = false
      })
    } catch (error) {
      console.log(error)
      runInAction(() => {
        this.loading = false
      })
    }
  }

  updateArduino = async (arduino: Arduino) => {
    this.loading = true
    try {
      await agent.Arduinos.update(arduino)
      runInAction(() => {
        this.arduinoRegistry.set(arduino.id, arduino)
        this.selectedArduino = arduino
        this.editMode = false
        this.loading = false
      })
    } catch (error) {
      console.log(error)
      runInAction(() => {
        this.loading = false
      })
    }
  }

  setValue = async (arduino: Arduino) => {
    this.loading = true
    try {
      let arduous = this.getArduino(arduino.id)
      if (arduous) {
        arduous = await agent.Arduinos.details(arduino.id)
        this.setArduino(arduous)
        runInAction(() => {
          this.selectedArduino = arduous
        })
      }
      // else {
      //   try {
      //     arduous = await agent.Arduinos.details(arduino.id);
      //     this.setArduino(arduous);
      //     runInAction(()=>{
      //       this.selectedArduino = arduous;
      //     });
      //   } catch (error) {
      //     console.log(error);
      //   }
      // }
      // arduino = arduous;
      runInAction(() => {
        this.selectedArduino = arduous
        this.updatedValue = true
        this.loading = false
        this.editMode = false
      })
    } catch (error) {
      console.log(error)
      runInAction(() => {
        this.loading = false
      })
    }
  }

  deleteArduino = async (id: string) => {
    this.loading = true
    try {
      await agent.Arduinos.delete(id)
      runInAction(() => {
        this.arduinoRegistry.delete(id)
        this.loading = false
      })
    } catch (error) {
      console.log(error)
      runInAction(() => {
        this.loading = false
      })
    }
  }
}
